import { mapGetters } from "vuex";

import MixinLimit from "@Mixins/limits";
import { XOrdersStore } from "@Modules/shoppingcart/Store/XOrdersStore";

import { IS_BILLING_PAGE_ENABLED } from "@Constants/env";

const isBillingPageEnabled = IS_BILLING_PAGE_ENABLED === "true";

export default {
  mixins: [MixinLimit],

  computed: {
    ordersStore() {
      return XOrdersStore();
    },

    ...mapGetters([
      "canUseApi",
      "canUseBrandedDomains",
      "isAccountUsageEnabled",
      "isOverhaulEnabled",
      "isUserSubscribed",
      "user",
    ]),

    featurePages() {
      return [
        {
          title: "Link Management",
          class: "home_header_button_linkmgmt",
          route: {
            name: "features.link-management",
            params: { keepQuery: true },
          },
        },
        {
          title: "Branded & Customized Links",
          class: "home_header_button_branded",
          route: {
            name: "features.custom-links",
            params: { keepQuery: true },
          },
        },
        {
          title: "Custom Branded Domains",
          route: {
            name: "branded-domains",
            params: { keepQuery: true },
          },
        },
        {
          title: "Campaign Monitoring & Analytics",
          class: "home_header_button_monitoring",
          route: {
            name: "features.link-analytics",
            params: { keepQuery: true },
          },
        },
        this.howWorksSetting,
        {
          title: "About TinyURL",
          class: "home_header_button_about",
          route: {
            name: "resources.about-us",
            params: { keepQuery: true },
          },
        },
      ];
    },

    regularSettings() {
      const self = this;

      return [
        {
          class: "account_sidebar_button_profile _sidebar-profile",
          name: self.$t("user:menu.profile"),
          icon: "fa-user",
          to: { name: "settings.profile" },
          condition: true,
        },
        /* {
          class: "",
          name: self.$t("user:menu.teams"),
          icon: "fa-users",
          to: { name: "settings.teams" },
          condition: self.teamsAllowed || self.supportTeams,
        }, */
        {
          class: "account_sidebar_button_security _sidebar-security",
          name: self.$t("user:menu.security"),
          icon: "fa-lock",
          to: { name: "settings.security" },
          condition: true,
        },
        {
          class: "account_sidebar_button_usage _sidebar-usage",
          name: self.$t("user:menu.usage"),
          icon: "fa-tachometer-alt",
          to: { name: "settings.usage" },
          condition: self.isAccountUsageEnabled,
        },
        {
          class: "",
          name: self.$t("user:menu.custom_pixel_scripts"),
          icon: "fa-eye",
          to: { name: "settings.pixelScripts" },
          condition: false,
        },
        {
          class: `account_sidebar_button_branded _sidebar-branded-domains ${
            self.$route.path.includes("purchase/domain")
              ? "router-link-active"
              : ""
          }`,
          name: self.$t("user:menu.branded_domains"),
          icon: "fa-globe",
          to: { name: "settings.brandedDomains" },
          condition: self.canUseBrandedDomains,
        },
        {
          class: "account_sidebar_button_api _sidebar-api",
          name: self.$t("user:menu.api"),
          icon: "fa-key",
          to: { name: "settings.api" },
          condition: self.canUseApi,
        },
        /* {
          class: "account_sidebar_fb_pexel",
          name: self.$t("user:menu.custom_pixel"),
          icon: "fa-eye",
          to: { name: "settings.pixelScripts" },
          condition: true,
        }, */
      ];
    },

    billingSettings() {
      const self = this;

      return [
        {
          class: "account_sidebar_button_subs _sidebar-subscription",
          name: self.$t("user:menu.subscription"),
          icon: "fa-sync",
          to: { name: "settings.subscription" },
          condition: true,
        },
        {
          class: "account_sidebar_button_orders _sidebar-orders",
          name: self.$t("user:menu.orders"),
          icon: "fa-history",
          to: { name: "shopping-cart.orders" },
          condition: self.isUserSubscribed || self.ordersStore.count,
        },
        {
          class: "account_sidebar_button_paymethod _sidebar-payment-method",
          to: { name: "settings.paymentMethod" },
          icon: "fa-credit-card",
          name: self.$t("user:menu.payment_method"),
          condition: !isBillingPageEnabled && self.isPaymentMethodVisible(),
        },
        {
          class: "account_sidebar_button_invoices _sidebar-invoices",
          to: { name: "settings.invoices" },
          icon: "fa-shopping-cart",
          name: self.$t("user:menu.invoices"),
          condition: !isBillingPageEnabled,
        },
        {
          class: "account_sidebar_button_billing_and_payment _sidebar-billing",
          name: self.$t("user:menu.billing_and_payment"),
          icon: "fa-shopping-cart",
          to: { name: "settings.billing" },
          condition: isBillingPageEnabled,
        },
      ];
    },

    kioskSettings() {
      const self = this;

      return [
        {
          icon: "fa-users",
          name: self.$t("user:kiosk.users"),
          to: "kiosk.users",
          block: 1,
        },
        {
          icon: "fa-link",
          name: self.$t("user:kiosk.aliases"),
          to: "kiosk.aliases",
          block: 1,
        },
        {
          icon: "fa-external-link-alt",
          name: self.$t("user:kiosk.longUrls"),
          to: "kiosk.longUrls",
          block: 1,
        },
        {
          icon: "fa-folder",
          name: self.$t("user:kiosk.domains"),
          to: "kiosk.domains",
          block: 1,
        },
        {
          icon: "fa-folder",
          name: self.$t("user:kiosk.banned_domains"),
          to: "kiosk.banned_domains",
          block: 1,
        },
        {
          icon: "fa-hand-holding-dollar",
          name: self.$t("user:kiosk.tld_overprice"),
          to: "kiosk.tld_overprice",
          block: 1,
        },
        {
          icon: "fa-money-bill-trend-up",
          name: self.$t("user:kiosk.overages"),
          to: "kiosk.overages",
          block: 1,
        },
        {
          icon: "fa-chart-bar",
          name: self.$t("user:kiosk.tinyurlStats"),
          to: "kiosk.tinyurlStats",
          block: 2,
        },
        {
          icon: "fa-user-shield",
          name: self.$t("user:kiosk.accessInvitations"),
          to: "kiosk.accessInvitations",
          block: 3,
        },
        {
          icon: "fa-book-dead",
          name: self.$t("user:kiosk.password_dictionary"),
          to: "kiosk.password_dictionary",
          block: 3,
        },
        {
          icon: "fa-globe",
          name: self.$t("user:kiosk.ips"),
          to: "kiosk.ips",
          block: 3,
        },
        {
          icon: "fa-puzzle-piece",
          name: self.$t("user:kiosk.cloudflareZones"),
          to: "kiosk.cloudflareZones",
          block: 3,
        },
        {
          icon: "fa-person-circle-question",
          name: self.$t("user:kiosk.surveys"),
          to: "kiosk.surveys",
          block: 3,
        },
        {
          icon: "fa-bullhorn",
          name: self.$t("user:kiosk.announcements"),
          to: "kiosk.announcements",
          block: 3,
        },
        {
          icon: "fa-tachometer-alt",
          name: self.$t("user:kiosk.systemStats"),
          to: "kiosk.systemStats",
          block: 3,
        },
      ];
    },

    howWorksSetting() {
      if (this.isOverhaulEnabled) {
        return {
          title: "Our Proven Process",
          route: { name: "resources.our-proven-process" },
        };
      }

      return {
        title: "How It Works",
        class: "home_header_button_howit",
        route: {
          name: "features.how-tinyurl-works",
          params: { keepQuery: true },
        },
      };
    },
  },

  methods: {
    /**
     * Indicates whether the "payment method" option is visible or not.
     */
    isPaymentMethodVisible() {
      const hasOwnedDomains = this.user.domains?.owned.length > 0;

      return this.isUserSubscribed || hasOwnedDomains;
    },
  },
};
